import React from 'react';

const UndergroundEdge = () => {
  return (
    <div 
      className="fixed pointer-events-none z-40 hidden md:block"
      style={{
        bottom: 0,
        right: 0,
        width: '400px',
        height: '400px',
        transform: 'translateX(0)',
      }}
    >
      <img
        src="/images/underground-edge.png"
        alt=""
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'right bottom',
        }}
      />
    </div>
  );
};

export default UndergroundEdge;
